module.exports = __webpack_public_path__ + "img/cross.d744066e.svg";